const welcomeKey = username => `kelimoNotificationWelcome:${username}`;
function shouldOfferNotifications(storage, username, status) {
  if (!username || !status?.available || status.enabled || status.disabled || !['default', 'granted'].includes(status.permissionState)) return false;
  try { return !storage.getItem(welcomeKey(username)) && storage.getItem(`kelimoPushDisabled:${username}`) !== '1'; }
  catch { return false; }
}
function rememberNotificationChoice(storage, username, choice) {
  try { storage.setItem(welcomeKey(username), choice); } catch {}
}
module.exports = { shouldOfferNotifications, rememberNotificationChoice };
